import React from 'react'
import style from './bowler.module.css'
import image1 from '../../images/1.png'
import image2 from '../../images/2.png'
import image3 from '../../images/3.png'
import image4 from '../../images/4.png'
import image5 from '../../images/5.png'
import playStore from '../../images/playStore.png';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
const Bowler = ({ visibleElements, elementsRef }) => {
    return (
        <main className={style['main']}>

            <section className={style['bowler']}
                ref={(el) => (elementsRef.current[16] = el)}>

                <div className={style['bowler__container']}>

                    <h1 className={`${style['bowler__title']} 
                    ${visibleElements.includes(elementsRef.current[21]) ?
                            style['bowler__title--transition'] : ''}`}>
                        Bowler Adventure.
                    </h1>

                    <div className={style['bowler__section']}
                        ref={(el) => (elementsRef.current[21] = el)}>

                        <h2 className={`${style['bowler__subtitle']} 
                        ${visibleElements.includes(elementsRef.current[21]) ?
                                style['bowler__subtitle--transition'] : ''}`}>
                            Bowler Adventure te lleva a niveles llenos de acción donde
                            debes demostrar tu destreza y reflejos.
                        </h2>

                        <p className={`${style['bowler__description']} 
                        ${visibleElements.includes(elementsRef.current[21]) ?
                                style['bowler__description--transition'] : ''}`}>
                            ¿Podrás superar los desafíos? <br />
                            ¡Únete a la aventura ahora y demuestra tu habilidad para
                            convertirte en el campeón definitivo de Bowler Adventure!
                        </p>

                    </div>

                    <div className={style['bowler__section']}
                        ref={(el) => (elementsRef.current[22] = el)}>

                        <div className={`${style['bowler__video']}
                        ${visibleElements.includes(elementsRef.current[22]) ?
                                style['bowler__video--transition'] : ''}`}>
                            <iframe
                                src='https://www.youtube.com/embed/HTfQCJuPeGY?=1&si=KMLVEpS9XzJRQQ3J'
                                title='Bowler Adventure Video'
                                frameBorder='0'
                                allow='accelerometer; 
                                clipboard-write; 
                                encrypted-media; 
                                gyroscope; 
                                picture-in-picture'
                                allowFullScreen
                            ></iframe>
                        </div>

                    </div>

                    <div className={style['bowler__section']}
                        ref={(el) => (elementsRef.current[23] = el)}>

                        <h2 className={`${style['bowler__subtitle']} 
                            ${visibleElements.includes(elementsRef.current[23]) ?
                                style['bowler__subtitle--transition'] : ''}`}>
                            Características del Juego:</h2>

                        <ul className={`${style['bowler__list']}
                        ${visibleElements.includes(elementsRef.current[23]) ?
                                style['bowler__list--transition'] : ''}`}>

                            <li>Mundos variados y desafiantes.</li>

                            <li>Diferentes skins.</li>

                            <li>Mecánica de esquivar.</li>

                            <li>Gráficos únicos.</li>

                            <li>Controles intuitivos.</li>

                        </ul>

                    </div>

                    <div className={style['bowler__section']}
                        ref={(el) => (elementsRef.current[24] = el)}>

                        <h2 className={`${style['bowler__subtitle']} 
                            ${visibleElements.includes(elementsRef.current[24]) ?
                                style['bowler__subtitle--transition'] : ''}`}>
                            Imágenes del Juego.</h2>

                        <div className={`${style['bowler__gallery']}
                            ${visibleElements.includes(elementsRef.current[24]) ?
                                style['bowler__gallery--transition'] : ''}`}>

                            <img src={image1} alt='Escena del juego 1' 
                            className='lazyload'/>
                            <img src={image2} alt='Escena del juego 2'
                            className='lazyload' />
                            <img src={image3} alt='Escena del juego 3'
                            className='lazyload' />
                            <img src={image4} alt='Escena del juego 4'
                            className='lazyload' />
                            <img src={image5} alt='Escena del juego 5'
                            className='lazyload' />

                        </div>

                    </div>

                    <div className={style['bowler__section']}
                        ref={(el) => (elementsRef.current[25] = el)}>
                        <div className='bowler__download'>

                            <h2 className={`${style['bowler__subtitle']} 
                            ${visibleElements.includes(elementsRef.current[25]) ?
                                    style['bowler__subtitle--transition'] : ''}`}>
                                Ya disponible en:</h2>
                            <div className={`${style['bowler__play-store']} 
                            ${visibleElements.includes(elementsRef.current[25]) ?
                                    style['bowler__play-store--transition'] : ''}`}>

                                <a href='https://play.google.com/store/apps/details?id=com.BrokenDev.BowlerAdventure&hl=es_CO'
                                    target='_blank' rel='noopener noreferrer'
                                    className='download-button'>
                                    <img
                                        src={playStore}
                                        alt='Descargar en Play Store'
                                        className='lazyload' />
                                </a>

                            </div>

                        </div>
                    </div>

                </div>

            </section>

        </main>
    );
};
export default Bowler;